webpackJsonp([4],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	module.exports = __webpack_require__(20);


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	/*
	require('common/facebook');
	require('common/ruutuembed');
	require('common/some-embed');
	require('./news');
	require('./video');
	require('./voting');
	require('./newsitemhit');
	*/


/***/ })

});


// WEBPACK FOOTER //
// site/news-item.4330cefc4f0a19cbf06f.js